import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@material-ui/core/Tooltip';
import UnkownIcon from '@material-ui/icons/HelpOutline';
import InitIcon from '@material-ui/icons/Adjust';
import OptimizingIcon from '@material-ui/icons/Settings';
import CompletedIcon from '@material-ui/icons/CheckCircleOutline';
import './JobSolveStatus.scss';

const UNKOWN = 0;
const INIT = 1;
const OPTIMIZING = 2;
const COMPLETED = 3;

const Tooltips = [];
Tooltips[UNKOWN] = 'UNKOWN';
Tooltips[INIT] = 'INIT';
Tooltips[OPTIMIZING] = 'OPTIMIZING';
Tooltips[COMPLETED] = 'COMPLETED';

const StatusClassnames = [];
StatusClassnames[UNKOWN] = 'status-unknown';
StatusClassnames[INIT] = 'status-init';
StatusClassnames[OPTIMIZING] = 'status-optimizing';
StatusClassnames[COMPLETED] = 'status-completed';

const JobSolveStatus = ({ value }) => {
  // value = LEAVING; // eslint-disable-line
  let Icon;
  switch (value) {
    case UNKOWN:
      Icon = <UnkownIcon />;
      break;
    case INIT:
      Icon = <InitIcon />;
      break;
    case OPTIMIZING:
      Icon = <OptimizingIcon className="grb-rotate" />;
      break;
    default:
      Icon = <CompletedIcon />;
      break;
  }
  return (
    <Tooltip
      title={Tooltips[value]}
    >
      <div className={`grb-jobsolvestatus ${StatusClassnames[value]}`}>
        {Icon}
      </div>
    </Tooltip>
  );
};

JobSolveStatus.propTypes = {
  value: PropTypes.number,
};

JobSolveStatus.defaultProps = {
  value: 0,
};

export default JobSolveStatus;
